import LeaveList from '@/controllers/teacher_leave/leave-list.js';

export default {
  extends: LeaveList,
  data() {
    return {
      searchData: {
        period: null,
        from_date: '',
        to_date: '',
        request_date: '',
        class_id: null,
        teacher_name: '',
        student_name: '',
        status: this.auth('teacher') ? 2 : null
      },
    }
  },
  methods: {
    reset() {
      this.employeeName = '';
      this.employeeNo = '';
      this.employmentType = '';
      this.teacherName = '';
      this.requestDate = '';
      this.status = '';
      this.leaveType = '';
      this.fromDate = '';
      this.toDate = '';
      this.teacherNo = '';
      this.isLoading = true;
      this.search_status = false;
      this.lastSearchParams = {};
      this.searchData = {
        employee_name: '',
        employee_no: '',
        employeeable_type: '',
        teacher_name: '',
        from_date: '',
        to_date: '',
        request_date: '',
        status: this.auth('teacher') ? 2 : null,
        leave_type: '',
        teacher_no: ''
      };
      this.getLeave();
    },
  }
}
